import { render, staticRenderFns } from "./ChangesReplacements.vue?vue&type=template&id=25b10616&"
import script from "./ChangesReplacements.vue?vue&type=script&lang=js&"
export * from "./ChangesReplacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports